import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  bulkUpdateEmployerJobs,
  fetchEmployerJobs,
  updateEmployerJobStatus,
  type EmployerJob,
  type EmployerJobFilters,
  type EmployerJobStatus,
} from '../api/employerJobs';

export function useEmployerJobs(filters: EmployerJobFilters) {
  return useQuery<EmployerJob[]>({
    queryKey: ['employer-jobs', filters.status ?? 'all'],
    queryFn: () => fetchEmployerJobs(filters),
    staleTime: 1000 * 30,
  });
}

export function useUpdateEmployerJobStatus(filters: EmployerJobFilters) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: EmployerJobStatus }) => updateEmployerJobStatus(id, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['employer-jobs', filters.status ?? 'all'] });
    },
  });
}

export function useBulkUpdateEmployerJobs(filters: EmployerJobFilters) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ ids, status }: { ids: string[]; status: EmployerJobStatus }) =>
      bulkUpdateEmployerJobs(ids, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['employer-jobs', filters.status ?? 'all'] });
    },
  });
}
